import axios from 'axios'
// import {
//   MessageBox,
//   Message
// } from 'element-ui'
import router from '../router'
import { debounce } from '../utils/utils';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000, // request timeout
})
const Env = process.env.VUE_APP_ENV
const traceSource = process.env.VUE_APP_TRACESOURCE
const token = process.env.VUE_APP_TOKEN
const traceSource_pc = process.env.VUE_PC_TRACESOURCE
const token_pc = process.env.VUE_PC_TOKEN


service.interceptors.request.use(
  config => {
    // console.log(config,'cofig')
    config.headers['actionFrom'] = 'PC'
    config.headers['access-token'] = localStorage.getItem('access_token') || '';
    config.headers['token'] = token_pc
    config.headers['traceSource'] = traceSource_pc
    // config.headers['cache-control'] = 'public, max-age=31536000, immutable'
    console.log(process.env,token,traceSource);
    
    if(window.navigator.userAgent.indexOf('toca') > -1){
        config.headers['FROM-TCGJ'] = 'true'
    }
    if(window.location.href.indexOf('middle') > -1){
      config.headers['FROM-TCGJ'] = 'QYWX'
  }
    // console.log('=========');
    console.log('===============',window.location.href);
    if(config.url.includes('genSchemeUrlOnly')){
        // console.log('=========222');
        config.baseURL = process.env.VUE_APP_MINIPROGRAM_API;
        config.headers['access-token'] = localStorage.getItem('access_token') || '';
        config.headers['token'] = token
        config.headers['traceSource'] = traceSource
        // config.headers['business'] = '100190'
        // config.headers['templateId'] = 589;
        console.log(token);
        console.log(localStorage.getItem('access_token'));
        console.log(traceSource);
        // config.headers['business'] = '100190'
        // config.headers['templateId'] = 589;
        console.log(config.baseURL);
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  async response => {
    const res = response.data
    if (res.code !== '0') {
      if (res.code === '401' || res.code === '402' || res.code === '403' || res.code === '1000_0003') {
        debounce(()=>{
            //   MessageBox.confirm(`${res.msg}，请重新登录`, '确认注销', {
            //     confirmButtonText: '重新登入',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            //   }).then(() => {
            //     localStorage.removeItem('access_token');
            //     router.push({
            //       path: '/login',
            //     });
            //   })
            localStorage.removeItem('access_token');
            localStorage.removeItem('isAutoDialog')
            router.replace({
              path: '/blank',
            });
        }, 1500)();
        return
      }
      return res
    //   const error = {
    //     msg: res.msg,
    //     code: res.code
    //   }
    //   throw error
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error.msg) // for debug
    // Message({
    //   message: error.msg || `网络异常,请重试`,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service